import React, {VoidFunctionComponent} from "react";

export const Argument: VoidFunctionComponent<{ title: string, content: string }> = ({title, content}) => {
    return (
        <div className='argument'>
            <p className='title'>{title}</p>
            <p className='content'>{content}</p>
        </div>
    );
};